/**
 * Created by chenzheyu on 2017/6/20.
 */
const data = {
  appKey: window.configure.appKey, // appKey
  acKey: window.configure.acKey, // AcKey
  WXappId: window.configure.WXappId, // 微信 APPid
  weixinUrl: window.configure.weixinUrl, // 微信Api
  serverUrl: window.configure.serverUrl, // 123 Api
  baiduKey: window.configure.baiduKey //  百度API Key
}
export default data


// WEBPACK FOOTER //
// ./src/store/configure.js